/**
 * Created by 影浅-seekwe@gmail.com on 2018-01-12
 */

const WEEKTYPE = {
  DAYNAME: 0,
  SDAYNAME: 1,
}

let _OPTIONS = {
  default: 'ZH',
  ZH: {
    daysAgo: '天前',
    hoursAgo: '小时前',
    MinutesAgo: '分钟前',
    SecondsAgo: '秒前',
    justNow: '刚刚',
    dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    shortDayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    shortMonthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  },
  US: {
    daysAgo: ' Days ago',
    hoursAgo: ' Hours ago',
    MinutesAgo: ' Minutes ago',
    justNow: ' Just now',
    SecondsAgo: ' Seconds ago',
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
}

export const setOptions = (options = {}) => {
  for (let k in options) {
    _OPTIONS[k] = options[k]
  }
}

const isInt = (str) => {
  return typeof str === 'number'
}
/**
 * 格式化时间
 * @param date
 * @param fmt
 * @returns {*}
 */
export const format = (date, fmt = 'yyyy-MM-dd hh:mm:ss') => {
  date = formatToDate(date)
  let o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'S': date.getMilliseconds() //毫秒
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * return Date
 */
export const formatToDate = (dateStr) => {
  if (!isNotEmpty(dateStr)) {
    throw ('argument format is wrong')
  }
  let date
  switch (true) {
    case isDate(dateStr):
      date = dateStr
      break
    case isInt(dateStr):
      date = new Date(dateStr)
      break
    default:
      date = new Date(Date.parse(dateStr.replace(/-/g, '/')))
  }
  return date
}

export const getDateStart = function(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  let datetime = format(date, 'yyyy-MM-dd') + ' 00:00:00'
  return (!fmt) ? formatToDate(datetime) : format(datetime, fmt)
}

export const getDateEnd = function(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  let datetime = format(date, 'yyyy-MM-dd') + ' 23:59:59'
  return (!fmt) ? formatToDate(datetime) : format(datetime, fmt)
}

export const compareDate = function(d1, d2) {
  d1 = formatToDate(d1)
  d2 = formatToDate(d2)
  if (d1 && d2) {
    if (d1.getTime() > d2.getTime()) {
      return 1
    } else if (d1.getTime() === d2.getTime()) {
      return 0
    } else if (d1.getTime() < d2.getTime()) {
      return -1
    }
  }
}

/**
 * 是否闰年
 */
export const isLeapYear = function(date) {
  date = formatToDate(date)
  return (0 === date.getYear() % 4 && ((date.getYear() % 100 !== 0) || (date.getYear() % 400 === 0)))
}
/**
 * 有否有效日期
 */
export const isValidDate = (dateStr) => {
  if (isNotEmpty(dateStr)) {
    const r = dateStr.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
    if (r === null) {
      return false
    }
    let d = new Date(r[1], r[3] - 1, r[4])
    let num = (d.getFullYear() === r[1] && (d.getMonth() + 1) === r[3] && d.getDate() === r[4])
    return (num !== 0)
  }
}

export const addDay = (dayNum, fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date) => {
  date = formatToDate(date)
  date.setDate(date.getDate() + dayNum)
  return !fmt ? date : format(date, fmt)
}

export const subtractDay = (dayNum, fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date) => {
  date = formatToDate(date)
  date.setDate(date.getDate() - dayNum)
  return !fmt ? date : format(date, fmt)
}

const monthBeforeFormatAndDay = (date, day) => {
  let mo = date.getMonth() + 1
  if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
    if (day >= 30) {
      day = 30
    }
  } else if (mo === 2) {
    if (isLeapYear(date)) {
      if (day >= 29) {
        day = 29
      } else {
        day = 28
      }
    } else if (day >= 28) {
      day = 28
    }
  } else { //大月
    if (day >= 31) {
      day = 31
    }
  }
  return day
}

export const addMonth = (monthNum, fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date) => {
  date = formatToDate(date)
  let currentDay = date.getDate()
  date.setMonth(date.getMonth() + monthNum, 1)
  let newDay = monthBeforeFormatAndDay(date, currentDay)
  date.setDate(date.getDate() + (newDay - 1))
  return !fmt ? date : format(date, fmt)
}

export const subtractMonth = (monthNum, fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date) => {
  date = formatToDate(date)
  let currentDay = date.getDate()
  date.setMonth(date.getMonth() - monthNum, 1)
  let newDay = monthBeforeFormatAndDay(date, currentDay)
  date.setDate(date.getDate() + (newDay - 1))
  return !fmt ? date : format(date, fmt)
}

export const addYear = (yearNum, fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date) => {
  date = formatToDate(date)
  date.setYear(date.getFullYear() + yearNum)
  return !fmt ? date : format(date, fmt)
}

export const subtractYear = (yearNum, fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date) => {
  date = formatToDate(date)
  date.setYear(date.getFullYear() - yearNum)
  return !fmt ? date : format(date, fmt)
}

export const isNotEmpty = (str) => {
  return str !== '' && str != null && typeof str !== 'undefined'

}

export const isDate = (str) => {
  return str instanceof Date

}
export const getWeek = (date, type) => {
  if (date) {
    if (!isNotEmpty(type)) {
      type = 0
    }
    let index = date.getDay()
    let dateStr = ''
    switch (type) {
      case WEEKTYPE.DAYNAME:
        dateStr = _OPTIONS[_OPTIONS.default].dayNames[index]
        break
      case WEEKTYPE.SDAYNAME:
        dateStr = _OPTIONS[_OPTIONS.default].shortDayNames[index]
        break
    }
    return dateStr
  }
}

export const getDateDiff = (date) => {
  if (!isDate(date)) {
    date = formatToDate(date)
  }
  let publishTime = parseInt(date.getTime() / 1000)
  let nowTime = parseInt(new Date().getTime() / 1000)
  let parsec = nowTime - publishTime
  let parsec_days = parseInt(parsec / 86400)
  let parsec_hours = parseInt(parsec / 3600)
  let parsec_minutes = parseInt(parsec / 60)
  let parsec_seconds = parseInt(parsec)

  if (parsec_days > 0 && parsec_days < 3) {
    return parsec_days + _OPTIONS[_OPTIONS.default].daysAgo
  } else if (parsec_days <= 0 && parsec_hours > 0) {
    return parsec_hours + _OPTIONS[_OPTIONS.default].hoursAgo
  } else if (parsec_hours <= 0 && parsec_minutes > 0) {
    return parsec_minutes + _OPTIONS[_OPTIONS.default].MinutesAgo
  } else if (parsec_seconds < 60) {
    if (parsec_seconds <= 0) {
      return _OPTIONS[_OPTIONS.default].justNow
    } else {
      return parsec_seconds + _OPTIONS[_OPTIONS.default].SecondsAgo
    }
  } else if (parsec_days >= 3 && parsec_days < 30) {
    return subtractDay(parsec_days, 'MM-dd hh:mm:ss')
  } else if (parsec_days >= 30) {
    return format(subtractDay(parsec_days), 'yyyy-MM-dd hh:mm:ss')
  }
}
export default format



// WEBPACK FOOTER //
// ./src/dateformat.js